var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-white p-6" }, [
        _vm.$apollo.queries.carePlanData &&
        _vm.$apollo.queries.carePlanData.loading
          ? _c(
              "div",
              { staticClass: "flex justify-center items-center py-10" },
              [
                _c("div", {
                  staticClass:
                    "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-blue",
                }),
              ]
            )
          : _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "block md:hidden mb-6 relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-between items-center bg-yellow-100 px-3 py-2 rounded-lg",
                    on: {
                      click: function ($event) {
                        _vm.showMobileDropdown = !_vm.showMobileDropdown
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "text-sm font-normal" }, [
                      _vm._v(_vm._s(_vm.getActiveTabName)),
                    ]),
                    _c(
                      "svg",
                      {
                        staticClass:
                          "w-5 h-5 transition-transform duration-300",
                        class: {
                          "transform rotate-180": _vm.showMobileDropdown,
                        },
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 9l-7 7-7-7",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm.showMobileDropdown
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mt-1 p-2 bg-white border border-gray-200 rounded-lg shadow-lg absolute left-0 right-0 z-10",
                      },
                      _vm._l(_vm.sidebarTabs, function (tab, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            staticClass:
                              "block w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded",
                            class:
                              _vm.activeTab === tab.id
                                ? "font-medium text-black"
                                : "text-gray-600",
                            on: {
                              click: function ($event) {
                                return _vm.selectMobileTab(tab.id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(tab.name) + " ")]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "flex flex-col md:flex-row" },
                [
                  _c("div", { staticClass: "hidden md:block left-side-bar" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "space-y-2 bg-default-light-grey left-side-bar-content",
                      },
                      _vm._l(_vm.sidebarTabs, function (tab, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            class: [
                              "w-full text-left px-4 py-2 rounded-lg focus:outline-none left-bar-button text-sm sm:text-lg font-normal",
                              _vm.activeTab === tab.id
                                ? "bg-yellow-100 font-medium text-black"
                                : "hover:bg-gray-50 text-gray-400",
                            ],
                            on: {
                              click: function ($event) {
                                _vm.activeTab = tab.id
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(tab.name) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm.activeTab === "clientInformation"
                    ? _c("ClientInformation", {
                        attrs: {
                          data: _vm.carePlanData,
                          proejctData: _vm.projectClientData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "risksAndAlerts"
                    ? _c("RisksAndAlerts", {
                        attrs: {
                          data: _vm.carePlanData,
                          proejctData: _vm.projectClientData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "clientServices"
                    ? _c("ClientServices", {
                        attrs: {
                          data: _vm.carePlanData,
                          proejctData: _vm.projectClientData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "goals"
                    ? _c("Goals", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "interventions"
                    ? _c("Interventions", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "functionalAssessment"
                    ? _c("FunctionalAssessment", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                          proejctData: _vm.projectClientData,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "homeEnvironment"
                    ? _c("HomeEnvironment", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "personalConsiderations"
                    ? _c("PersonalConsiderations", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm.activeTab === "documentationRequirements"
                    ? _c("DocumentationRequirements", {
                        attrs: {
                          data: _vm.carePlanData,
                          currentUser: _vm.currentUser,
                        },
                        on: { edit: _vm.handleEdit },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
      ]),
      _vm.showEditModal
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.showEditModal,
              activeTab: _vm.activeTab,
              initialData: _vm.formattedCarePlanData,
              companyId: _vm.company.id,
              isCareplanExist: _vm.isCareplanExist,
              currentUser: _vm.currentUser,
              currentEditTab: _vm.currentEditTab,
              isEdit: true,
            },
            on: {
              close: _vm.closeEditModal,
              closeDialog: _vm.hanldeCancel,
              "save-draft": _vm.handleSaveDraft,
              "update:formData": _vm.updateFormData,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }